import React, { Component } from 'react';
import { Row, Col, Container } from 'reactstrap'

class Footer extends Component {

    render() {
        return (
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col>
                            <p>
                                Designed and Developed by <a href="https://tech4lifebs.com/">tech4life</a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        );
    }
}

export default Footer;